<template>
  <div class="propWrap">
    <div class="el-message-box el-message-box--center" style="overflow-y: auto;padding: 0" :style="{width:width,height:height}">
      <div class="el-message-box__header">
        <div class="el-message-box__title">
          <span class="prop-title">{{ title }}</span>
        </div>
        <button v-show="isShowClose" type="button" aria-label="Close" class="el-message-box__headerbtn">
          <i class="el-message-box__close el-icon-close" style="font-size: 0.2rem" @click="closeProp"></i>
        </button>
      </div>
      <div class="el-message-box__content" style="display:block;margin: 0;padding: 0;">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "propWrap",
  props: {
    width: {
      type: String,
      default: '7rem'
    },
    height: {
      type: String,
      default: '6rem'
    },
    title: {
      type: String,
      default: null
    },
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {
    closeProp() {
      this.$emit('closeProp', false)
    }
  }
}
</script>

<style lang="less" scoped>

.prop-title {
  font-size: 0.16rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/propWrap.vue